<template>
  <div class="row">
    <div class="col-md-6" v-if="detailedInfo.hasOwnProperty('driver')">
      <card-list-info header="Vehicle Information" :items="vehicleInfo">
        <template slot="driver" slot-scope="{data}">
          Driver : <router-link :to="`/employees/${data.value.id}`">{{ data.value.name }}</router-link>
        </template>
      </card-list-info>
    </div>
    <div class="col-md-6">
      <card-list-info v-if="isHaveContainerInfo" header="Vehicle Container Information" :items="vehicleContainerInfo"></card-list-info>
    </div>
    <div class="col-md-6" v-if="isHaveGpsDevicesInfo">
      <card-list-info
        v-for="(gps, index) in VehicleGPSInfo"
        :key="gps"
        :header="`Vehicle GPS Information ${index + 1}`"
        :items="gps">
      </card-list-info>
    </div>
  </div>
</template>

<script>
  import dateMixin from '@/mixins/date';
  import { isEmpty, get } from 'lodash';
  import CardListInfo from '@/components/CardListInfo';

  export default {
    mixins: [dateMixin],
    components: {
      CardListInfo,
    },
    created() {
      this.$store.dispatch('vehicles/LOAD_DETAIL_DATA');
    },
    computed: {
      detailedInfo() {
        return this.$store.getters['vehicles/get_detail_data'];
      },
      isHaveContainerInfo() {
        return !isEmpty(this.detailedInfo.container);
      },
      isHaveGpsDevicesInfo() {
        return !isEmpty(this.detailedInfo.gps_devices);
      },
      detailedCompanyInfo() {
        return this.detailedInfo.company;
      },
      vehicleInfo() {
        const { driver = {} } = this.detailedInfo;
        const infoList = [
          { key: 'reg_no', label: 'Reg Number', value: this.detailedInfo.reg_no },
          { key: 'driver', label: 'Driver', value: { name: this.get(driver, 'name'), id: this.get(driver, 'id') } },
          {
            key: 'created_at',
            label: 'Created at',
            value: this.formatDateDistance(this.detailedInfo.created_at),
            title: this.formatDateTime(this.detailedInfo.created_at),
          },
        ];

        return infoList;
      },
      vehicleContainerInfo() {
        if (this.isHaveContainerInfo) {
          const {
            height, length, type, width,
          } = this.detailedInfo.container;
          const infoList = [
            { key: 'height', label: 'Height', value: height },
            { key: 'length', label: 'Length', value: length },
            { key: 'type', label: 'Type', value: type },
            { key: 'width', label: 'Width', value: width },
          ];

          return infoList;
        }

        return [];
      },
      VehicleGPSInfo() {
        const { gps_devices: gpsDevices = [] } = this.detailedInfo;
        const gpsItems = gpsDevices.map(gps => ([
          {
            key: 'number',
            label: 'Number',
            value: gps.number,
          },
          {
            key: 'type',
            label: 'Type',
            value: gps.type,
          },
          {
            key: 'created_at',
            label: 'Created at',
            value: this.formatDateDistance(gps.created_at),
            title: this.formatDateTime(gps.created_at),
          },
        ]));

        return gpsItems;
      },
    },
    methods: {
      get(object, key) {
        return get(object, key) || '-';
      },
    },
  };
</script>

<style scoped lang="sass">

</style>



// WEBPACK FOOTER //
// src/views/pages/vehicle/detail/Index.vue